var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Burger Menu"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Burger Menu_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    d: "M39 12H3C1.89543 12 1 12.8954 1 14C1 15.1046 1.89543 16 3 16H39C40.1046 16 41 15.1046 41 14C41 12.8954 40.1046 12 39 12Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Base_2",
    d: "M39 26H3C1.89543 26 1 26.8954 1 28C1 29.1046 1.89543 30 3 30H39C40.1046 30 41 29.1046 41 28C41 26.8954 40.1046 26 39 26Z",
    fill: "#347AF0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/BurgerMenu.b2ea362f1dfd129e350d648d7fd8255e.svg";
export { ForwardRef as ReactComponent };